const initFiltersBackendModel = {
    page: 1,
    max_rows: 10,
    line_height: 40,
    columns: [
        {
            column_name: "sortField",
            active: false,
            value: "creation_date"
        },
        {
            column_name: "sortOrder",
            active: false,
            value: "desc"
        },
        {
            column_name: "filterLabel",
            active: false,
            value: ""
        },
        {
            column_name: "filterDestination",
            active: false,
            value: ""
        },
        {
            column_name: "filterShortUrl",
            active: true,
            value: ""
        },
        {
            column_name: "filterOrganisation",
            active: true,
            value: ""
        },
        {
            column_name: "filterDate",
            active: true,
            value: ""
        },
        {
            column_name: "filterType",
            active: true,
            value: ""
        },
        {
            column_name: "filterStatus",
            active: true,
            value: ""
        },
        {
            column_name: "filterBrand",
            active: true,
            value: ""
        },
        {
            column_name: "filterRange",
            active: true,
            value: ""
        },
        {
            column_name: "filterMember",
            active: false,
            value: ""
        },
        {
            column_name: "filterGtin",
            active: false,
            value: ""
        },
        // Short URL column visibility (display-only — `filterShortUrl` is the
        // legacy GTIN column key, so this one gets its own name).
        {
            column_name: "filterProductShortUrl",
            active: false,
            value: ""
        },
    ]
}

const initFilters: any = {
    page: 1,
    sortField: "creation_date",
    sortOrder: "desc",
    filterBrand: "",
    filterRange: "",
    filterLabel: "",
    filterOrganisation: "",
    filterStatus: "",
    filterDestination: "",
    filterCampaign: "",
    filterBatchId: "",
    filterShortUrl: "",
    filterMember: "",
    filterDate: "",
    filterType: "",
    filterGtin: "",
    filterProductShortUrl: "",
    maxRows: 10,
    lineHeight: 40,
}

const formatFiltersBody = (filters: any, columns: any) => {

    let _columns: any = []

    initFiltersBackendModel.columns.forEach((column: any) => {
        _columns.push({
            column_name: column.column_name,
            value: filters[column.column_name],
            active: columns[column.column_name]
        })
    })

    return {
        page: filters.page,
        max_rows: filters.maxRows,
        line_height: filters.lineHeight,
        columns: _columns,
    }
}

const getQueryUrl = (_filters: any) => {

    if (!_filters) return null

    // TODO: i think something's wrong here
    const filters = _filters ?? initFiltersBackendModel

    let params = new URLSearchParams({
        page: filters.page as unknown as string,
        max_rows: filters.maxRows as unknown as string,
        // sortField: filters.sortField,
        // sortOrder: filters.sortOrder,
    });

    if (!!filters.filterLabel) params.append("search", filters.filterLabel)
    if (!!filters.filterDestination) params.append("default_url", filters.filterDestination)
    if (!!filters.filterShortUrl) params.append("filterShortUrl", filters.filterShortUrl)
    if (!!filters.filterDate) params.append("created_at", filters.filterDate)
    if (!!filters.filterOrganisation) params.append("org", filters.filterOrganisation)
    if (!!filters.filterType) params.append("type", filters.filterType)
    if (!!filters.filterBrand) params.append("brand", filters.filterBrand)
    if (!!filters.filterRange) params.append("range", filters.filterRange)
    if (!!filters.filterStatus) params.append("archived", filters.filterStatus)
    if (!!filters.filterGtin) params.append("gtin", filters.filterGtin)
    // Creator filter: the org-tree user_id (users.uuid backend-side), not an
    // email — the org owner has no invitation row so email matching would miss
    // them. The UI displays the email, the uuid is what travels.
    if (!!filters.filterMember) params.append("owner", filters.filterMember)
    // if (!!filters.filterBatchId) params.append("filterBatchId", filters.filterBatchId)

    return `${params.toString()}`;
}

export { getQueryUrl, formatFiltersBody, initFilters, initFiltersBackendModel }